module.exports = __webpack_public_path__ + "static/img/small-button-check.0f51ec04.svg";